import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import Form from "@/core/components/Form";
import {
  Field,
  LegalArea,
  Locales,
  PageViewTitle,
  TranslationTenant,
} from "@/core/types/types";
import { initUseCase } from "@/core/useCases/init";
import { useClaimCheck } from "@/core/hooks/useClaimCheck/useClaimCheck";
import CamundaService from "server/service/CamundaService";
import { pushVirtualPageView as pushVirtualGtmPageView } from "@/core/lib/gtm/gtm";
import { pushVirtualPageView as pushVirtualHotjarPageView } from "@/core/lib/hotjar/hotjar";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import { pushVirtualPageView as pushVirtualDataDogView } from "@/core/lib/datadog/datadog";

// This gets called at build time
export async function getStaticPaths() {
  // TODO: this should come from Camunda
  return {
    paths: [{ params: { step: "airports" } }],
    fallback: false,
  };
}

// This gets called at build time
export async function getStaticProps() {
  // TODO: we should avoid starting a new process at build time
  // For this we need the backend to provide an endpoint that
  // returns the initial form definition
  const initialForm = await initUseCase();
  const translations = await CamundaService.getTranslations(
    Locales.DE,
    TranslationTenant.FLIGHTRIGHT,
    LegalArea.APR
  );
  return { props: { formComponents: initialForm.components, translations } };
}

export default function Step({ formComponents }: { formComponents: Field[] }) {
  const router = useRouter();
  const { submitStep } = useClaimCheck();
  const initialisationConfig = useContext(ConfigContext);
  const definitionName = initialisationConfig?.definitionName;
  const domain: string = `${initialisationConfig?.brandId}.${initialisationConfig?.domain}`;

  useEffect(() => {
    pushVirtualGtmPageView(PageViewTitle.Airports, definitionName);
    pushVirtualHotjarPageView(PageViewTitle.Airports);
    pushVirtualDataDogView(PageViewTitle.Airports, definitionName, domain);
  }, []);

  const onSubmit = async (formAnswers: any) => {
    await submitStep(formAnswers);

    // Redirect to the SPA
    router.replace("/");
  };

  return <Form formComponents={formComponents} onSubmit={onSubmit} />;
}
